import React from 'react'

import { TtIcon } from '@23/react'

import './FocusPreviewTrayNotes.scss'

const FocusPreviewTrayNotes = () => {
  return (
    <div className="focus-preview-tray-notes">
      <div className="focus-preview-tray-notes-before" />
      <div className="focus-preview-tray-notes-item" />
      <div className="focus-preview-tray-notes-slide">
        <TtIcon library="one/webinars" name="note" />
      </div>
      <div className="focus-preview-tray-notes-item" />
      <div className="focus-preview-tray-notes-after" />
    </div>
  )
}

export { FocusPreviewTrayNotes }
